import { renderMenuItems } from "../../utils/render-menu-items";
import { Menu } from "@/base/index";
import { useHeaderNavigateStyles } from "./header-navigate.styles";
import { useMenu } from "@/app/hook/use-menu";

export const HeaderNavigateMenu = () => {
  const { styles } = useHeaderNavigateStyles();
  const menuItems = useMenu("main");

  return (
    <div className={styles.menu}>
      <Menu
        theme="dark"
        mode="horizontal"
        selectable={false}
        items={renderMenuItems(menuItems || [])}
        className={styles.menuComponent}
      />
    </div>
  );
};
